var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9.5 2a7.5 7.5 0 0 1 5.964 12.048l6.243 6.245a1 1 0 0 1-1.414 1.414l-6.245-6.243A7.5 7.5 0 1 1 9.5 2zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }